import React, { useState } from "react";
import { Menu, X } from "lucide-react";

const ALL_LINKS = [
  { id: "about", key: "about", label: "عن النادي" },
  { id: "why-us", key: "why_us", label: "لماذا تختارنا" },
  { id: "goals", key: "goals", label: "أهدافنا" },
  { id: "team", key: "team", label: "اللجان" },
  { id: "member-of-month", key: "mom", label: "أعضاء الشهر" },
  { id: "workshops", key: "workshops", label: "الفعاليات والدورات" },
  { id: "achievements", key: "achievements", label: "الإنجازات" },
  { id: "contact", key: "contact", label: "تواصل" },
];

export default function Navbar({ content }) {
  const [open, setOpen] = useState(false);
  const hidden = content?.hidden_sections || [];
  const order = content?.section_order || [];
  const links = ALL_LINKS.filter((l) => !hidden.includes(l.key)).sort((a, b) => order.indexOf(a.key) - order.indexOf(b.key));

  const scrollTo = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      data-testid="navbar"
      className="fixed top-0 right-0 left-0 z-50 bg-[#1A0F0E]/85 backdrop-blur-md border-b border-[#F0E8DB]/20"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 h-20 flex items-center justify-between">
        <a href="#" data-testid="nav-logo" className="flex items-center gap-3">
          <img src="/logo.jpg" alt="شعار نادي المسرح" data-testid="nav-logo-image" className="h-14 w-auto rounded-lg object-contain border border-[#F0E8DB]/40 gold-glow" />
          <div className="hidden sm:block leading-tight">
            <div className="text-[#F0E8DB] font-semibold text-base">نادي المسرح</div>
            <div className="text-[#F0E8DB] text-xs font-serif-en tracking-widest">THEATER CLUB</div>
          </div>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="px-4 py-2 text-[#D6CBBF] hover:text-[#F0E8DB] transition text-sm rounded"
            >
              {l.label}
            </button>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-2">
          <button
            data-testid="nav-join-button"
            onClick={() => scrollTo("contact")}
            className="btn-gold rounded-full px-5 py-2 text-sm"
          >
            انضم إلينا
          </button>
          <a
            data-testid="nav-login-button"
            href="/admin/login"
            className="btn-ghost rounded-full px-4 py-2 text-sm"
          >
            لوحة التحكم
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-[#F0E8DB] p-2"
          onClick={() => setOpen(!open)}
          aria-label="menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden bg-[#1A0F0E] border-t border-[#F0E8DB]/20 px-4 py-3 flex flex-col gap-1">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              className="text-right px-3 py-2 text-[#D6CBBF] hover:text-[#F0E8DB] hover:bg-[#241615] rounded"
            >
              {l.label}
            </button>
          ))}
          <button onClick={() => scrollTo("contact")} className="btn-gold rounded-full py-2 mt-2 text-sm">
            انضم إلينا
          </button>
          <a href="/admin/login" className="btn-ghost rounded-full py-2 text-sm text-center mt-1">
            لوحة التحكم
          </a>
        </div>
      )}
    </nav>
  );
}
